import type { HelpFile } from '../../types/help'
import { PeerRecommendationListTestIds } from '../../../testids/PeerRecommendationListTestIds'

export const peerRecommendationListHelp: HelpFile = {
  docPage: '/docs/access/peer-recommendations',
  texts: {
    [PeerRecommendationListTestIds.peerRecommendationList]:
      'Access Profiles that peers in the same role or organisation already hold — use these to spot likely missing access without browsing the full catalogue.',
    [PeerRecommendationListTestIds.peerRecommendationListTitle]: null,
    [PeerRecommendationListTestIds.peerRecommendationListItems]: 'One recommendation per row — click "Add" to include the suggested Access Profile in the current request.',
  },
}
